import { render, staticRenderFns } from "./RouteFileNewPage.vue?vue&type=template&id=60d06b26&"
import script from "./RouteFileNewPage.vue?vue&type=script&lang=js&"
export * from "./RouteFileNewPage.vue?vue&type=script&lang=js&"
import style0 from "./RouteFileNewPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports